import LocaleResolver from "csi/config/LocaleResolver";
import { declare } from "csi/def/ActionFactory";
import Request from "csi/def/Request";
import ReflectionClass from "csi/reflection/ReflectionClass";
import lang from "dojo/_base/lang";
import { C8Node } from "src/c8-platform/type/node";
import Approve from "./Approve";

const ApproveConfirm = declare("ApproveConfirm", Approve, {
	m_tag: "ApproveConfirm",

	resolve(lr: LocaleResolver, rcRoot: ReflectionClass, nodeRoot: C8Node): void {
		// summary: initialize post-processing and request if not already set
		this.m_postAction = this.m_postAction || "postActionRedrawNode";
		this.m_request = this.m_request || lang.mixin(new Request(), { m_module: this.m_module, m_operation: "Approve" });
		this.inherited(arguments);
	},
});

export = ApproveConfirm;